import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import MoneyIcon from  '@material-ui/icons/SwapHoriz';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },                          
  icon: {
    color: theme.palette.success.main,
    height: 24,
    width: 24                       
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}));

const LengthCard = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              Distance Flat
            </Typography>
            <Typography variant="h3">5.23km</Typography>
          </Grid>
          <Grid item>
           
              <MoneyIcon className={classes.icon} />
           
          </Grid>
        </Grid> 
      </CardContent>
    </Card>
  );
};

LengthCard.propTypes = {
  className: PropTypes.string
};

export default LengthCard;
